import useSWR from 'swr'
import { getSession, getUserPreference, getUserProfile, getUsers, settingsServiceApiPaths } from './settingsApi'

export const useUserProfile = (userId?: string | null, config: any = {}) => {
  const { data, error } = useSWR(userId ? settingsServiceApiPaths.user(userId) : null, getUserProfile, { ...config })

  return {
    data,
    error,
    isLoading: !data && !error,
  }
}

export const useUserSession = (userId?: string | null, config: any = {}) => {
  const { data, error } = useSWR(userId, getSession, { ...config })

  return {
    data,
    error,
    isLoading: !data && !error,
  }
}

export const useUsers = (config: any = {}) => {
  const { data, error, mutate } = useSWR(settingsServiceApiPaths.users, getUsers, { ...config })

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  }
}

export const useTenantPreference = (key?: string | null) => {
  const { data, error, mutate } = useSWR(
    key ? settingsServiceApiPaths.tenantPreferencesGet(key) : null,
    getUserPreference,
  )

  return {
    data,
    error,
    isLoading: null === data && !error,
    mutate,
  }
}

export const useCustomerPreference = (key?: string | null) => {
  const { data, error, mutate } = useSWR(
    key ? settingsServiceApiPaths.customerPreferencesGet(key) : null,
    getUserPreference,
  )

  return {
    data,
    error,
    isLoading: null === data && !error,
    mutate,
  }
}

export const useUserPreference = (key?: string | null) => {
  const { data, error, mutate } = useSWR(
    key ? settingsServiceApiPaths.userPreferencesGet(key) : null,
    getUserPreference,
  )

  return {
    data,
    error,
    isLoading: null === data && !error,
    mutate,
  }
}

export const useTenantUserPreference = (key?: string | null) => {
  const { data, error, mutate } = useSWR(
    key ? settingsServiceApiPaths.tenantUserPreferencesGet(key) : null,
    getUserPreference,
  )

  return {
    data,
    error,
    isLoading: null === data && !error,
    mutate,
  }
}
